import ServiceLocator from "../../../../../../ServiceLocator";
import ZLogger from "../../../../../../util/zlogger/zlogger";

/**
 * Helper to claim farm2 feeds. Uses Xing to communicate with
 * farm2 iframe and change status accordingly
 */
var Farm2FeedClaim = (function () {
    var _queue = [];    /* The queue of feeds yet to be processed */
    var _xingRegistered = false;    /* Has this controller registered itself with Xing? */
    var _pingDone = false;  /* Did a ping test go through? */
    var _txnNumber = 0;
    var _txnRegister = {};  /* A register which keeps track of txn id to referrer instance mapping */
    var _flushing = false;

    /* Rules compliant with Xing for feeds */
    var _claimRules = [
        {
            activated: false,
            handler: (d) => {
                ZLogger.log("PINGPONG: recvd: ", d);
                // Only if the relay data contains this signature
                // its considered to be complete
                if (d.sig !== undefined && d.sig === "fv2pong") {
                    // Ping pong compelte
                    _pingDone = true;
                    ZLogger.log("PINGPONG: starting flush");
                    // Start flushing
                    _flush();
                }
            },
            passes: [
                ServiceLocator.Xing.XingChecker.Validate,
                ServiceLocator.Xing.XingChecker.IsPong,
            ],
            name: "fv2pong"
        },
        {
            activated: false,
            handler: (feedResp) => {
                var success = (feedResp.statusMessage || feedResp.hasOwnProperty('statusMessage')) && !feedResp.hasOwnProperty('errorMessage');
                var txnId = feedResp.transactionId;
                var responseCode = feedResp.errorCode;
                if (success) {
                    var statusMessage = feedResp.statusMessage;
                    _handleSuccessClaim(txnId, statusMessage, responseCode);
                } else {
                    var errorMessage = feedResp.errorMessage;
                    if (errorMessage) {
                        _handleFailedClaim(txnId, errorMessage, responseCode);
                    }
                }
            },
            passes: [
                ServiceLocator.Xing.XingChecker.Validate,
                (d) => { return d.type === _constants.UWG_TYPE_INGRESS_FEED_RESP }
            ],
            name: "UWG_FEED_RESP"
        }
    ]

    /* Internal constants */
    var _constants = {
        fv2IframeID: "farm2-game-frame",
        UWG_TYPE_EGRESS_FEED_CLAIM: "UWG_FEED_CLAIM",
        UWG_TYPE_INGRESS_FEED_RESP: "UWG_FEED_RESP",
        UWG_TYPE_INGRESS_PONG: "fv2pong"
    }

    /* handler when a feed claim is success */
    // transactionId = "0", statusMessage = "You accepted this reward successfully!", responseCode = 0, errorMessage = ""
    function _handleSuccessClaim(txnId, statusMessage, responseCode) {
        var referrer = _getReferrer(txnId);
        if (referrer) {
            referrer.progressState(responseCode, statusMessage);
            ZLogger.log("=====>>> FEED SUCCESS: ", txnId, statusMessage, responseCode);
            // Finally remove the referrer
            _deleteReferrer(txnId);
        }
    }

    /* handler when a feed claim failed */
    function _handleFailedClaim(txnId, errorMessage, responseCode) {
        var referrer = _getReferrer(txnId);
        if (referrer) {
            referrer.progressState(responseCode, errorMessage);
            ZLogger.log("=====>>> FEED FAIL: ", txnId, errorMessage, responseCode);
            // Finally remove the referrer
            _deleteReferrer(txnId);
        }
    }

    /* handler when a feed is queued */
    function _handleQueuedClaim(txnId) {
        var referrer = _getReferrer(txnId);
        if (referrer) {
            ZLogger.log("===Q==>>> FEED Qd: ", txnId);
        }
    }

    /* gets the referrer from txnRegister */
    function _getReferrer(txnId) {
        return _txnRegister[txnId];
    }

    /* deletes a referrer entry from txnRegister and prevents from bloating */
    function _deleteReferrer(txnId) {
        delete _txnRegister[txnId];
    }

    function _validateFeed(proposedFeed) {
        return (
            proposedFeed !== undefined &&
            /*    _ Left intentionally: We wouldnt want txn id to be passed but to be calculated here itself for consistency  */
            /*   /   */
            /*  v    */
            // proposedFeed.transactionId !== undefined && 
            proposedFeed.chnl !== undefined &&
            proposedFeed.href !== undefined
        )
    }

    function _getNewTxnId() {
        return ++_txnNumber;
    }

    function _addToQueue(referrer, tbdFeed) {
        if (referrer !== undefined && _validateFeed(tbdFeed)) {
            tbdFeed.transactionId = '' + _getNewTxnId();
            // Put a ref in register
            _txnRegister[tbdFeed.transactionId] = referrer
            // push in queue
            _queue.push(tbdFeed);
            // Update button state
            _handleQueuedClaim(tbdFeed.transactionId);
        } else {
            ZLogger.error("Invalid feed formatting; rejected: ", tbdFeed);
        }
    }

    function Try(thatButton, tbdFeed) {
        if (!_xingRegistered) {
            // Then register rules with Xing
            ServiceLocator.Xing.RegisterRules(_claimRules);
            ServiceLocator.Xing.ActivateRules(_claimRules);
            _xingRegistered = true;
        }
        if (!_pingDone) {
            // Then do a ping-pong for connectivity checks
            ServiceLocator.Xing.Send(
                _constants.fv2IframeID,
                ServiceLocator.Xing.XingConstants.UWG_TYPE_EGRESS_PING,
                {
                    "sig": "fv2pong",
                    "msg": "FV2 Ping-pong test"
                }
            )
        }
        _addToQueue(thatButton, tbdFeed);
        _flush();
    }

    function _flush() {
        // If ping is not approved or we are already flushing
        // by another async flush call made earlier then leave.
        if (!_pingDone || _flushing) return;
        _flushing = true;
        ZLogger.log("Flush: ", _queue.length);
        while (_queue.length > 0) {
            var feed = _queue.shift();
            // Process feed
            ZLogger.log("==__p__==> processing feed: ", feed);
            ServiceLocator.Xing.Send(
                _constants.fv2IframeID,
                _constants.UWG_TYPE_EGRESS_FEED_CLAIM,
                feed
            )
            // Change button state till we recieve a response
        }
        _flushing = false;
    }

    return {
        Try: Try
    }
})();

export default Farm2FeedClaim;